"use client";

import ContactUsClient from "@/components/ContactUsClient";

export default function ContactPage() {
  return <ContactUsClient />;
}
